import styled from 'styled-components'

import MuiDialog from '@mui/material/Dialog'
import MuiDialogContent from '@mui/material/DialogContent'
import MuiDialogTitle from '@mui/material/DialogTitle'
import MuiIconButton from '@mui/material/IconButton'
import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Dialog = styled(MuiDialog)`
  & .MuiDialog-paper {
    position: relative;
    width: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    border-radius: 16px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  }
`

export const DialogHeader = styled(MuiDialogTitle)`
  && {
    padding: 0;
    padding-top: 42px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`

export const CloseButton = styled(MuiIconButton)`
  && {
    position: absolute;
    right: 16px;
    top: 16px;
    padding: 0;
    height: 16px;
    width: 16px;
  }
`

export const DialogTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  color: ${baseTheme.colors.lightDark};
`

export const DialogContent = styled(MuiDialogContent)`
  && {
    padding: 0 16px 40px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`
